<template lang='pug'>
  div.root-component-container.pattern-background-purple
    v-container.fill-height(fluid)
      v-row.justify-center
        v-col.d-flex.justify-end(cols='10' md='6' xl='4')
          AccountOptionsBar(light)
      v-row.justify-center.fill-height
        v-col.d-flex.flex-column.fill-height(cols='10' md='6' xl='4')
          div.flex-grow-1.d-flex.justify-center.align-center
            v-img.fade-15(src='/quickytools.svg' :max-width="$vuetify.breakpoint.width<400 ? 128 : 256")

    MailingListDialog(v-model="showMailingListDialog" list-key="day6-marketing" :title='day6Resource.day6Updates')
</template>

<script>
import day6Resource from '@/resources/day6'
import AccountOptionsBar from '../account/account-options-bar.vue'
import MailingListDialog from '../mailingList/mailing-list-add.vue'

export default {
  name: 'Day6MailingList',
  components: { AccountOptionsBar, MailingListDialog },
  data: function () {
    return {
      day6Resource,
      showMailingListDialog: false
    }
  },
  mounted () {
    this.showMailingListDialog = true
  }
}
</script>
